// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.course-slider-container {
  display: flex;
  overflow-x: auto;
  gap: 16px;
  padding: 20px;
  background-color: #f8f9fc;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;

  scrollbar-width: none;
  -ms-overflow-style: none;
}
.course-slider-container::-webkit-scrollbar {
  display: none;
}

.course-pill {
  min-width: 140px;
  max-width: 140px;
  height: 50px;
  background-color: #fff;
  padding: 12px;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  color: #444;
  font-weight: 500;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  scroll-snap-align: start;
  flex-shrink: 0;
  transition: transform 0.2s;
  cursor: pointer;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/assets/courseSlider/CourseTypeSlider.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,iCAAiC;;EAEjC,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".course-slider-container {\n  display: flex;\n  overflow-x: auto;\n  gap: 16px;\n  padding: 20px;\n  background-color: #f8f9fc;\n  scroll-snap-type: x mandatory;\n  -webkit-overflow-scrolling: touch;\n\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n.course-slider-container::-webkit-scrollbar {\n  display: none;\n}\n\n.course-pill {\n  min-width: 140px;\n  max-width: 140px;\n  height: 50px;\n  background-color: #fff;\n  padding: 12px;\n  border-radius: 12px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);\n  color: #444;\n  font-weight: 500;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  scroll-snap-align: start;\n  flex-shrink: 0;\n  transition: transform 0.2s;\n  cursor: pointer;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
